import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';

import { declarations } from '@shared/shared.declarations';

import { AccountService } from '@shared/services/account/account.service';
import { BorrowerService } from '@shared/services/borrower/borrower.service';
import { CommonLibraryModule } from '@common-library/common-library.module';
import { EmailService } from '@shared/services/email/email.service';
import { ForkCommonControlsModule } from '@shared/fork-common-controls/fork-common-controls.module';
import { LDComponentsModule } from '../ld-angular-components';
import { LoanApplicationDisclosureService } from '@app/pages/personal-loans/shared/services/loan-application-disclosure.service';
import { PipesModule } from '@shared/pipes/pipes.module';
import { RegisterFormProvider } from '../pages/personal-loans/shared/formProviders/register-form.provider';
import { TooltipModule } from '@shared/tooltip';
import { TrackScrollModule } from '@shared/directives/track-scroll/track-scroll.module';
import { UlaSvgIconComponent } from '@shared/svg-icon/ula-svg-icon.component';
import { UlaSvgIconModule } from '@shared/svg-icon/ula-svg-icon.module';
import { UserConfirmationService } from './services/user-confirmation/user-confirmation.service';

@NgModule({
  declarations,
  imports: [
    CommonLibraryModule,
    CommonModule,
    ForkCommonControlsModule,
    FormsModule,
    LDComponentsModule,
    ModalModule.forRoot(),
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    TooltipModule,
    TrackScrollModule,
    UlaSvgIconModule,
  ],
  exports: [
    declarations,
    CommonModule,
    CommonLibraryModule,
    PipesModule,
    ForkCommonControlsModule,
    TrackScrollModule,
    TooltipModule,
    UlaSvgIconComponent
  ],
  providers: [
    AccountService,
    BorrowerService,
    EmailService,
    LoanApplicationDisclosureService,
    RegisterFormProvider,
    UserConfirmationService,
  ]
})
export class SharedModule { }
